<template>
  <div class="filter-mobile">
    <div class="filter-mobile__label display-flex-wrap justify-content-between">
        <div
          class="item item--class btn btn-gray border-rd-20 display-flex-center justify-content-center"
          :class="{'active': selectBoxOpen === 'class'}"
          @click="handleCollapseSelect('class')"
        >
          <span
            class="item__name font-sanpro-semibold font-size-16"
            :class="{'primary-color': selectBoxOpen === 'class', 'secondary-color-txt': selectBoxOpen !== 'class'}"
          >
            {{ classes[classIndexActive].name }}
          </span>
          <span class="item__icon">
            <i
              class="icon-arrow-down font-size-12"
              :class="{'primary-color': selectBoxOpen === 'class', 'secondary-color-txt': selectBoxOpen !== 'class'}"
            ></i>
          </span>
        </div>
        <div
          class="item item--type btn btn-gray border-rd-20 display-flex-center justify-content-center"
          :class="{'active': selectBoxOpen === 'type'}"
          @click="handleCollapseSelect('type')"
        >
          <span
            class="item__name font-sanpro-semibold font-size-16"
            :class="{'primary-color': selectBoxOpen === 'type', 'secondary-color-txt': selectBoxOpen !== 'type'}"
          >
            Loại học liệu
          </span>
          <span class="item__icon">
            <i
              class="icon-arrow-down font-size-12"
              :class="{'primary-color': selectBoxOpen === 'type', 'secondary-color-txt': selectBoxOpen !== 'type'}"
            ></i>
          </span>
        </div>
    </div>
    <FilterCollapseMobile :chooseLabel="selectBoxOpen" @changeSelectBox="handleCollapseSelect" />
    <div class="filter-mobile__body">
      <div v-if="selectBoxOpen === 'class'" class="filter-mobile__class display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of classes"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15"
          :class="{'active primary-color': selectClass === item.classId, 'secondary-color-txt': selectClass !== item.classId}"
          @click="filterDataLibsByClass(item, index)"
        >
          {{ item.classNo }}
        </a>
      </div>
      <div v-else-if="selectBoxOpen === 'type'" class="filter-mobile__types display-flex-wrap justify-content-between">
        <a
          v-for="(item, index) of types"
          :key="index"
          href="javascript:;"
          class="item btn btn-gray border-rd-20 font-sanpro-semibold font-size-15 full-width"
          :class="{'active primary-color': routerQuery.tab && routerQuery.tab.toString() === item.id.toString(), 'secondary-color-txt': !routerQuery.tab || (routerQuery.tab && routerQuery.tab.toString() !== item.id.toString())}"
          @click="filterLibByTab(item.id)"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import FilterCollapseMobile from './FilterCollapseMobile.vue'

export default {
  name: 'FilterMobile',
  props: {
    selectClass: Number,
    classes: Array,
    types: Array,
  },
  components: {
    FilterCollapseMobile
  },
  data() {
    return {
      selectBoxOpen: '', // class, type
    };
  },
  computed: {
    classId () {
      return parseInt(this.$route.query.lop)
    },
    classIndexActive () {
      let result = 0
      if (this.$route.query.lop) {
        result = this.classes.findIndex(cl => cl.classId === parseInt(this.$route.query.lop))
      }
      return result
    },
    tabActive () {
      return parseInt(this.$route.query.tab) || 0
    },
    routerQuery() {
      return this.$route.query
    },
  },
  methods: {

    filterDataLibsByClass(classItem, index) {
      this.classId !== classItem.classId && this.$emit('searchClass', {classItem, index})
    },

    filterLibByTab(tab) {
      this.tabActive !== tab && this.$emit('searchTab', tab)
    },

    handleCollapseSelect (type) {
      this.selectBoxOpen = this.selectBoxOpen === type ? '' : type
    },
  }
};
</script>

<style lang="scss" scoped>
.filter-mobile {
  &__label {
    .item {
      width: 49%;
      margin-bottom: 10px;
    }
  }
}
</style>
